import { SETTINGS_RECEIVED } from '../action-list';

export default function(state = {}, action) {
  switch (action.type) {
    case SETTINGS_RECEIVED:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
